import { render, staticRenderFns } from "./ManageSupplier.vue?vue&type=template&id=638f5b4a&scoped=true"
import script from "./ManageSupplier.vue?vue&type=script&lang=js"
export * from "./ManageSupplier.vue?vue&type=script&lang=js"
import style0 from "./ManageSupplier.vue?vue&type=style&index=0&id=638f5b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f5b4a",
  null
  
)

export default component.exports